import { styled } from '@mui/material';

export const CardStyled = styled('div', {
  shouldForwardProp: (prop) => !['hasImage'].includes(prop as string),
})(({ theme, hasImage }) => ({
  padding: `${theme.spacings.unit(4)} ${theme.spacings.unit(
    3
  )} ${theme.spacings.unit(6.3425)}`,
  backgroundColor: theme.tables.evenRowBackgroundColor,
  color: theme.colors.primaryText,
  minHeight: hasImage ? theme.spacings.unit(110) : theme.spacings.unit(85.5),
  height: '100%',
}));

export const Website = styled('h2')(({ theme }) => ({
  margin: `0 0 ${theme.spacings.unit(5)}`,
  fontSize: theme.fonts.utility.size(10),
  letterSpacing: theme.spacings.unit(0.125),
}));

export const FieldContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  margin: `${theme.spacings.unit(3.75)} 0`,
}));

export const FieldHeader = styled('h3')(({ theme }) => ({
  fontSize: theme.fonts.utility.size(6),
  color: theme.colors.primary,
  letterSpacing: theme.spacings.unit(0.075),
  margin: `0 0 ${theme.spacings.unit(1.75)} 0`,
}));

export const FieldText = styled('span')(({ theme }) => ({
  fontSize: theme.fonts.utility.size(10),
  color: theme.colors.primaryText,
  letterSpacing: theme.spacings.unit(0.125),
}));

export const InfoWithImage = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacings.unit(1),
  alignItems: 'center',
}));

export const ImageContainer = styled('div')(({ theme }) => ({
  width: theme.spacings.unit(6),
  height: theme.spacings.unit(6),
  position: 'relative',
  alignSelf: 'center',
}));
